const styles = {
  root: {
    padding: 0.5,
    border: 1,
    borderColor: 'background.border',
    borderRadius: 1,
    backgroundColor: 'background.default',
  },
  ratingNumber: {
    color: 'text.primaryDark',
    fontWeight: '600!important',
    textAlign: 'center',
    lineHeight: '14px!important',
    marginTop: '5px',
  },
  rating: {
    fontSize: 9,
    paddingRight: 1,
  },
  ratingText: {
    fontSize: '11px!important',
    color: 'text.primaryDark',
    fontWeight: '400!important',
    lineHeight: '12px!important',
    paddingY: 1,
    paddingRight: 1,
  },
}

export default styles
